import { Button, Card, Col, Drawer, Form, notification, Row } from 'antd'
import moment from 'moment/moment'
import React from 'react'
import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { formItemLayout } from '../../../components/_utils/appUtils'
import { addAbstractViewNoteFxn, getNotesWithCountFxn } from './actions'

@Form.create()
class AbstractNotesDrawer extends React.Component {
  state = {
    noteData: [],
    noteCount: 0
  }

  componentDidMount() {
    this.loadNotes()
  }

  // loadNotes = async () => {
  //   const { abstractId } = this.props
  //   const data = await getNotesWithCountFxn({ abstractId })
  //   console.log("DEBUG: Full API Response:", data);
  //   // Force extraction to array; ensure we handle the object vs array correctly
  //   const notes = Array.isArray(data.list) ? data.list : (data.notes || [])
  //
  //   this.setState({
  //     noteData: notes,
  //     noteCount: data.count || notes.length
  //   })
  loadNotes = async () => {
    const { abstractId } = this.props;
    const data = await getNotesWithCountFxn({ abstractId });

    // Based on your logs, the real list is at data.list.list
    // And the real count is at data.list.count
    const notesArray = (data.list && data.list.list) ? data.list.list : [];
    const countValue = (data.list && data.list.count) ? data.list.count : 0;

    console.log("DEBUG: Final extraction:", notesArray);

    this.setState({
      noteData: notesArray,
      noteCount: countValue
    });
  }  // }
  handleSubmit = e => {
    const { form, abstractId } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.abstractId = abstractId
        valData.time = moment().format('lll')

        let resp = await addAbstractViewNoteFxn(valData)

        if (resp && resp.success) {
          notification.success({ message: 'Note added successfully' })
          form.resetFields()
          this.loadNotes()
        }
      } else {
        notification.error({ message: 'Please enter all required fields.' })
      }
    })
  }

  render() {
    const { noteData, noteCount } = this.state
    const { form: { getFieldDecorator }, visible, onClose } = this.props

    const inputSchema = [
      {
        label: 'Add Note',
        key: 'note',
        required: true,
        type: 'textArea',
        placeholder: 'Add Note'
      }
    ]

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        width={'70%'}
        title={`Notes (${noteCount})`}>
        <Card bordered={false}>
          <Form onSubmit={this.handleSubmit} hideRequiredMark className={'inputForm'}>
            <Row gutter={16}>
              {inputSchema.map((item, key) => (
                <Col span={24} key={key}>
                  <GetEachFormFields
                    item={item}
                    getFieldDecorator={getFieldDecorator}
                    formItemLayout={formItemLayout}
                  />
                </Col>
              ))}
              <Col span={24}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Col>

              {/* Defensive Mapping: Check Array.isArray explicitly */}
              <Col span={24}>
                {Array.isArray(noteData) && noteData.length > 0 ? (
                  noteData.map((item, i) => (
                    <div key={i} className="custom_card mb10">
                      <Card
                        bordered={true}
                        title={item.addedBy || 'Admin'}
                        extra={moment(item.time).format('DD.MM.YYYY, h:mm A')}>
                        {item.note}
                      </Card>
                    </div>
                  ))
                ) : (
                  <p>No notes found.</p>
                )}
              </Col>
            </Row>
          </Form>
        </Card>
      </Drawer>
    )
  }
}

export default connect(null)(AbstractNotesDrawer)
